














































































































































import { defineComponent } from '@vue/composition-api'
import { get, isFunction, isObject } from 'lodash'
import TableRender from './table-render.vue'
import TableHeaderRender from './header-render'
export default defineComponent({
  name: 'TemplateTable',
  components: {
    TableRender,
    TableHeaderRender
  },
  props: {
    columns: [],
    data: [],
    operations: {
      type: Array,
      default: () => []
    },
    operationWidth: {
      type: String,
      default: '180px'
    },
    fiexdHeader: {
      type: Boolean,
      default: false
    },
    showIndexColumn: {
      type: Boolean,
      default: false
    },
    showSelectColumn: {
      type: Boolean,
      default: false
    },
    multipleSelection: {
      type: Array,
      default: () => {
        return []
      }
    },
    moreLength: {
      type: Number,
      default: 3
    },
    emptyText: {
      type: String,
      default: '暂无数据'
    }
  },
  setup() {
    const formatter = (columnConfig: any) => {
      const formatFn = (row: any, column: any, cellValue: any) => {
        let output = cellValue
        if (Array.isArray(cellValue)) {
          const res: any = cellValue.map((item: any) => {
            if (isObject(item)) {
              const key = get(columnConfig, 'key', 'name')
              return get(item, key, '')
            }
            return item
          })
          const divider = get(columnConfig, 'divider', ',')
          output = res.join(divider)
        }
        return output || columnConfig.empty || output
      }
      return formatFn
    }

    return {
      formatter
    }
  },
  computed: {
    showOperations: () => {
      return get(this, 'operations', []).length
    }
  },
  updated() {
    const tableNode: any = this.$refs.table
    tableNode?.doLayout()
  },
  methods: {
    getButtonArr(index: string | number, row: any) {
      const buttons = this.operations.filter((btn: any) =>
        this.handleFunc(btn.showHandler, index, row, btn.role)
      )
      if (buttons.length === this.moreLength) {
        return buttons
      }
      return buttons.slice(0, this.moreLength - 1)
    },
    getDropdownArr(index: string | number, row: any) {
      const buttons = this.operations.filter((btn: any) =>
        this.handleFunc(btn.showHandler, index, row, btn.role)
      )
      if (buttons.length === this.moreLength) {
        return []
      }
      return buttons.slice(this.moreLength)
    },
    handleFunc(
      handler: Function,
      index: string | number,
      row: any,
      role: string
    ) {
      if (isFunction(handler)) {
        return handler(index, row, role)
      } else {
        return true
      }
    },
    operationEvent(index: string | number, row: any, role: string) {
      // 获取按钮实例
      const refs = this.$refs as any
      this.$emit('operation-event', row, role, index, refs[role][index] || null)
    },
    /** 判断操作按钮是否为disabled */
    checkDisable(disableHandler: any, row: any) {
      if (!disableHandler) {
        return false
      }
      return disableHandler(row)
    },
    handleSelectionChange(val: any) {
      this.$emit('update:multipleSelection', val)
    }
  }
})
